import React from "react";
import { Layout } from "../../layout/page";
import { ProfileContent } from "../../content/profile";

export function Profile() {
  return (
    <Layout>
      <ProfileContent />
    </Layout>
  );
}
